<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iColumn
    :width="fullTextOptionsAttributes.width"
    :height="fullTextOptionsAttributes.height"
    :min-width="fullTextOptionsAttributes.minWith"
    :max-width="fullTextOptionsAttributes.maxWith"
  >
    <iText
      v-bind="fullTextOptionsAttributes"
      :border-top="myBorderSides.top"
      :border-bottom="myBorderSides.bottom"
      :border-left="myBorderSides.left"
      :border-right="myBorderSides.right"
      :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
      :style="[!renderedText && editMode ? {opacity: 0.5} : null, clickableStyle]"
      :class="{'clickable-text': hasClickValue}"
      @click="handleClickAction"
    >
      {{ renderedText || (editMode ? placeholderText : "") }}
    </iText>
  </iColumn>
</template>

<script>
// Production base for branded text variants (Title/Heading/SubHeading/
// Paragraph/Label/Note). Mirrors `BrandedTextElement.vue` but skips the
// iRichText branch, the link-picker modal, and every editor-only watcher.
//
// Mounted by `DynamicComponentBuilderElement` for unselected branded-text
// elements and on non-default breakpoint frames. Selection re-routes
// mounting back to the Builder variant so the active element keeps the
// rich-text editing affordances.
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";
import {
  BrandedTextElementRenderMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/branded-text-element-render-mixin";

export default {
  name: "BrandedTextElementProduction",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  mixins: [BrandedTextElementRenderMixin],
  hidden: true,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "text",
    }),
  ],
};
</script>

<style lang="scss" scoped>
.clickable-text {
  cursor: pointer !important;
}
</style>
